// OIDC Authorization Code + PKCE با Keycloak (ADR-006، ARD-security-iam §4.2). توکن‌ها فقط در حافظه (InMemoryWebStorage)؛
// فقط وضعیت گذرای PKCE (state و code_verifier، نه توکن) در sessionStorage همان تب می‌ماند تا Redirect کار کند و
// پس از Callback پاک می‌شود (C-AGENT-130).
import {
  InMemoryWebStorage,
  UserManager,
  WebStorageStateStore,
  type UserManagerSettings,
} from 'oidc-client-ts';

export interface OidcConfig {
  /** Issuer، مثل http://localhost:8080/realms/phoenix-staff */
  authority: string;
  /** phoenix-staff-app یا phoenix-console */
  clientId: string;
  /** Origin اپ (پیش‌فرض window.location.origin). */
  origin?: string;
  scope?: string;
}

export const POPUP_CALLBACK_PATH = '/auth/popup-callback';

export function createUserManager(config: OidcConfig): UserManager {
  const origin = config.origin ?? window.location.origin;
  const settings: UserManagerSettings = {
    authority: config.authority,
    client_id: config.clientId,
    redirect_uri: `${origin}/`,
    post_logout_redirect_uri: `${origin}/`,
    popup_redirect_uri: `${origin}${POPUP_CALLBACK_PATH}`,
    response_type: 'code',
    scope: config.scope ?? 'openid profile email',
    // تمدید با Refresh Token (Keycloak: Refresh یک‌بارمصرف، نشست SSO حداکثر ۱۲ ساعت — BR-IAM-003).
    automaticSilentRenew: true,
    accessTokenExpiringNotificationTimeInSeconds: 60,
    loadUserInfo: false,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() }),
    stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  };
  return new UserManager(settings);
}

/** آیا URL جاری پاسخ Redirect ورود (code و state) است؟ */
export function isSigninCallback(location: Location = window.location): boolean {
  const params = new URLSearchParams(location.search);
  return params.has('state') && (params.has('code') || params.has('error'));
}
